import { render, staticRenderFns } from "./travelFooter.vue?vue&type=template&id=64ea1592&scoped=true&"
import script from "./travelFooter.vue?vue&type=script&lang=js&"
export * from "./travelFooter.vue?vue&type=script&lang=js&"
import style0 from "./travelFooter.vue?vue&type=style&index=0&id=64ea1592&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea1592",
  null
  
)

export default component.exports